export default class BrowserWindow {
  static getHostName(): string {
    return window.location.hostname;
  }
}
